import { FilterWorkerProvider } from "src/contexts/FilterWorkerContext";
import { OpaqueOverlay as StyledInstances } from "../styles";
import Breadcrumbs from "./Breadcrumbs";
import Table from "./Table";
import Close from "src/containers/Close";
import FileViewer from "src/components/Main/Viewer.js";

const Instance = () => {
  return (
    <FilterWorkerProvider>
      <StyledInstances>
        <Close />
        <Breadcrumbs />
        <Table />
        <FileViewer />
      </StyledInstances>
    </FilterWorkerProvider>
  );
};

export default Instance;
